import RegexParser from 'regex-parser';
import { isValidCron } from 'cron-validator';
import * as mr from 'multi-integer-range';

class SettingsValidator {
  public validateSettings(settingDefs: any[] = [], settings: any, t: any) {
    const errors = {} as any;
    let hasError = false;
    for (const section of settingDefs) {
      for (const item of section.items) {
        if (!this.isItemVisible(item, settings)) {
          continue;
        }
        if (item.type === 's' || item.type === 't' || item.type === 'json') {
          if (item.required && !settings[item.name]) {
            errors[item.name] = t('common.errors.requiredField');
            hasError = true;
          }
        } else if (item.type === 'cron') {
          if (item.required && !settings[item.name]) {
            errors[item.name] = t('common.errors.requiredField');
            hasError = true;
          } else if (settings[item.name] && !isValidCron(settings[item.name])) {
            errors[item.name] = t('common.errors.invalidField');
            hasError = true;
          }
        } else if (item.type === 'regex') {
          if (item.required && !settings[item.name]) {
            errors[item.name] = t('common.errors.requiredField');
            hasError = true;
          } else if (settings[item.name]) {
            try {
              RegexParser(settings[item.name]);
            } catch (e) {
              errors[item.name] = t('common.errors.invalidField');
              hasError = true;
            }
          }
        } else if (item.type === 'numRanges') {
          if (item.required && !settings[item.name]) {
            errors[item.name] = t('common.errors.requiredField');
            hasError = true;
          } else if (settings[item.name]) {
            try {
              const ranges = mr.parse(settings[item.name]);
              if (ranges.length === 0) {
                errors[item.name] = t('common.errors.requiredField');
                hasError = true;
              } else {
                errors[item.name] = [...mr.iterate(ranges)].join(',');
              }
            } catch (e) {
              errors[item.name] = 'Please enter valid page ranges';
              hasError = true;
            }
          }
        } else if (item.type === 'l' || item.type === 'ml') {
          if (item.required && (!settings[item.name] || settings[item.name].length === 0)) {
            errors[item.name] = t('common.errors.requiredField');
            hasError = true;
          }
        } else if (item.type === 'n') {
          if (item.required && !settings[item.name] && settings[item.name] !== 0) {
            errors[item.name] = t('common.errors.requiredField');
            hasError = true;
          } else if (item.minValue !== undefined && settings[item.name] < item.minValue) {
            errors[item.name] = t('common.errors.minValue', { value: item.minValue });
            hasError = true;
          } else if (item.maxValue !== undefined && settings[item.name] > item.maxValue) {
            errors[item.name] = t('common.errors.maxValue', { value: item.maxValue });
            hasError = true;
          }
        }
      }
    }
    return [errors, hasError];
  }

  public isItemVisible(item: any, settings: any) {
    if (item.system) {
      return false;
    }
    if (!item.conditions) {
      return true;
    }
    let pass = true;
    for (let condition of item.conditions) {
      if (Array.isArray(condition.settingValue)) {
        if (!condition.settingValue.includes(settings[condition.settingName])) {
          pass = false;
          break;
        }
      } else {
        if (
          condition.settingValue === false ||
          condition.settingValue === null ||
          condition.settingValue === undefined
        ) {
          if (settings[condition.settingName]) {
            pass = false;
            break;
          }
        } else if (!(settings[condition.settingName] === condition.settingValue)) {
          pass = false;
          break;
        }
      }
    }
    return pass;
  }
}

export default SettingsValidator;
